import React, { useId } from 'react';

import { Checkbox } from '@/components/ui/checkbox';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface LibrarySelectionCheckboxProps {
    label: string;
    checked: boolean;
    onToggle: () => void;
    disabledReason?: string;
}

export const LibrarySelectionCheckbox: React.FC<LibrarySelectionCheckboxProps> = ({
    label,
    checked,
    onToggle,
    disabledReason,
}) => {
    const reasonId = useId();

    if (!disabledReason) {
        return <Checkbox checked={checked} onCheckedChange={onToggle} aria-label={label} />;
    }

    return (
        <>
            <Tooltip delayDuration={0}>
                <TooltipTrigger asChild>
                    {/* Disabled controls cannot receive focus; the wrapper exposes the reason instead. */}
                    <span
                        role="checkbox"
                        aria-checked={checked}
                        aria-disabled="true"
                        aria-label={label}
                        aria-describedby={reasonId}
                        tabIndex={0}
                        className="focus-visible:ring-ring inline-flex shrink-0 cursor-not-allowed rounded focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
                    >
                        <Checkbox
                            checked={checked}
                            disabled
                            aria-hidden="true"
                            tabIndex={-1}
                            className="pointer-events-none"
                        />
                    </span>
                </TooltipTrigger>
                <TooltipContent className="max-w-xs">{disabledReason}</TooltipContent>
            </Tooltip>
            <span id={reasonId} className="sr-only">
                {disabledReason}
            </span>
        </>
    );
};
